import { Button, ButtonGroup, Grid } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import { TableSortLabel } from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import MoreVertRoundedIcon from "@material-ui/icons/MoreVertRounded";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useHistory } from "react-router-dom";
import http from "../services/httpService";

import {
  addContentManagementPath,
  editContentManagementPath,
  getDate,
  searchFilter,
  handleSort,
} from "../utils/varialbles";
import SearchBar from "material-ui-search-bar";

const useStyles = makeStyles({
  root: {
    width: "100%",
  },
});
const columns = [
  { id: "title", label: "Title", minWidth: 150 },
  {
    id: "content_updated_at",
    label: "Updated Date",
    minWidth: 150,
    format: "Date",
  },

  { id: "detailsButton", label: "Options", minWidth: 150, align: "right" },
];
function CMSOverView() {
  const classes = useStyles();
  const history = useHistory();
  const [publishedActive, setPublishedActive] = useState(true);
  const [archivedActive, setArchivedActive] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const isMenuOpen = Boolean(anchorEl);
  const [currentRecord, setCurrentRecord] = useState({});
  const [tabs, setTabs] = useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [rows, setRows] = React.useState([]);
  const [searched, setSearched] = React.useState("");
  const [orignalRows, setOriginalRows] = React.useState([]);
  const [orderBy, setOrderBy] = React.useState("cust__createddt");
  const [order, setOrder] = React.useState("asc");
  const requestSearch = (searchedVal) => {
    let rowsTemp = [...orignalRows];

    setPage(0);
    setRows(searchFilter(searchedVal, rowsTemp));
  };

  const cancelSearch = () => {
    setSearched("");
    requestSearch(searched);
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleRequestSort = (e, property, format) => {
    let isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
    let tempRows = [...rows];
    let finalRows = handleSort(property, format, tempRows, isAsc);

    setRows(finalRows);
    setPage(0);
  };

  const changePath = (event) => {
    event.preventDefault();
    history.push(addContentManagementPath);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };
  const viewProspectDetails = (object) => { };
  let tabsList = [
    {
      text: "Published Posts",
      path: "/contentmanagement",
      name: "publishedPostsButton",
      active: publishedActive,
    },
    {
      text: "Archived Posts",
      path: "/archivedcontentmanagement",
      name: "archivedPostsButton",
      active: archivedActive,
    },
  ];
  useEffect(() => {
    localStorage.removeItem("prospectFilter");
    localStorage.removeItem("investmentFilter");
    localStorage.removeItem("ticketFilter");
    localStorage.removeItem("internalFilter")
    localStorage.removeItem("selectedfiltersdata")
    localStorage.removeItem("selectedinvestorfiltersdata")

    toast.loading("Please wait...");
    http.get("/login_permissions").then((res) => {
      if (
        res &&
        res.data &&
        res.data.Data &&
        Array.isArray(res.data.Data) &&
        res.data.Data.length > 0
      ) {
        let current_permission = res.data.Data.filter((obj) => {
          return obj.Mainmenu === "Content Management System";
        });
        if (current_permission && current_permission.length > 0) {
          let finalTabsList = tabsList.filter((object) => {
            if (current_permission[0]["Submenus"].indexOf(object.text) !== -1) {
              return object;
            }
          });
          if (finalTabsList[0]["name"] === "archivedPostsButton") {
            setTabs(finalTabsList);
            makeActive("/archivedcontentmanagement");
          } else {
            setTabs(finalTabsList);
            makeActive("/contentmanagement");
          }
        }
        toast.dismiss();
      }
    });
  }, []);
  const handleMenuOpen = (event, record) => {
    let currentTarget = event.currentTarget;
    setCurrentRecord(record);
    setAnchorEl(currentTarget);
  };
  const handlePatchRecord = (e, record, archive) => {
    http
      .patch("/updatearchivedcontent/" + currentRecord.id + "/", {
        archived: archive,
      })
      .then((res) => {
        if (res && res.data && res.data.id) {
          if (archive) {
            toast.success("Content Archived Successfully");
            makeActive("/contentmanagement");
          } else {
            toast.success("Content UnArchived Successfully");
            makeActive("/archivedcontentmanagement");
          }
        } else {
          toast.error("Content Update Failed!");
        }

        setAnchorEl(null);
      })
      .catch((err) => {
        toast.error("Content Update Failed!");
      });
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  const handleEditRecord = (e, row) => {
    history.push({ pathname: editContentManagementPath, state: currentRecord });
  };
  const makeActive = (event) => {
    toast.loading("Please wait...");

    setPublishedActive(false);
    setArchivedActive(false);

    if (event === "/contentmanagement") {
      setPublishedActive(true);
    } else {
      setArchivedActive(true);
    }

    http
      .get(event)
      .then((response) => {
        toast.dismiss();

        if (
          response &&
          response.data &&
          Array.isArray(response.data) &&
          response.data.length > 0
        ) {
          setOriginalRows(response.data);
          setRows(response.data);
        } else {
          setOriginalRows([]);
          setRows([]);
        }
      })
    // .catch((error) => { });
  };
  return (
    <div className={(classes.root, "pb30")}>

      <AppBar
        position="static"
        style={{ marginBottom: 5, paddingTop: 3, paddingBottom: 3 }}
      >
        <Grid container component="main">
          <Grid item xs={12} sm={6} md={6} className={"buttongroup"}>
            <ButtonGroup className={"buttongroup"}>
              {tabs.map((obj, inx) => {
                return (
                  <Button
                    variant={
                      obj.name === "publishedPostsButton" && publishedActive
                        ? "contained"
                        : obj.name === "archivedPostsButton" && archivedActive
                          ? "contained"
                          : "outlined"
                    }
                    color="primary"
                    style={{ marginLeft: 10, borderRadius: 60 }}
                    onClick={() => makeActive(obj.path)}
                    name={obj.name}
                    key={obj.name}
                  >
                    {obj.text}
                  </Button>
                );
              })}
            </ButtonGroup>
          </Grid>
          <Grid item xs={12} sm={3} md={3} className={"buttongroup"}>
            <Button
              variant="contained"
              color="primary"
              style={{ borderRadius: 60 }}
              onClick={changePath}
              name="addPostsButton"
              className="addBtn"
            >
              Add Post
            </Button>
          </Grid>
        </Grid>
      </AppBar>
      <Paper className={classes.root}>
        <SearchBar
          value={searched}
          onChange={(searchVal) => requestSearch(searchVal)}
          onCancelSearch={() => cancelSearch()}
          className={"mt30"}
        />

        <TablePagination
          rowsPerPageOptions={[5, 10, 15, 25, 50, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    <TableSortLabel
                      active={orderBy === column.id}
                      direction={orderBy === column.id ? order : "asc"}
                      onClick={(e) =>
                        handleRequestSort(e, column.id, column.format)
                      }
                    >
                      {column.label}
                    </TableSortLabel>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length !== 0 ? (
                <>
                  {rows
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, index) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={index + "a"}
                        >
                          {columns.map((column, index) => {
                            const value = row[column.id];
                            return (
                              <TableCell
                                key={index + column.id}
                                align={column.align}
                              >
                                {column.format && typeof value === "number" ? (
                                  column.format(value)
                                ) : column.id === "detailsButton" ? (
                                  <>
                                    <MoreVertRoundedIcon
                                      variant="outlined"
                                      style={{ cursor: "pointer" }}
                                      aria-controls={index + column.id + "menu"}
                                      aria-haspopup="true"
                                      onClick={(e) => handleMenuOpen(e, row)}
                                    />
                                    <Menu
                                      anchorEl={anchorEl}
                                      id={index + column.id + "menu"}
                                      keepMounted
                                      open={isMenuOpen}
                                      onClose={handleMenuClose}
                                      getContentAnchorEl={null}
                                      transformOrigin={{
                                        horizontal: "center",
                                        vertical: "bottom",
                                      }}
                                      anchorOrigin={{
                                        horizontal: "right",
                                        vertical: "bottom",
                                      }}
                                    >
                                      <MenuItem
                                        onClick={(e) => handleEditRecord(e, row)}
                                      >
                                        View/Edit
                                      </MenuItem>
                                      {/* onClick={e=>handleEditRecord(e,row)} */}
                                      {/* <MenuItem onClick={e=>handleDeleteRecord(e,row)} >Delete</MenuItem> */}
                                      <MenuItem
                                        onClick={(e) =>
                                          handlePatchRecord(e, row, true)
                                        }
                                        style={
                                          archivedActive
                                            ? { display: "none" }
                                            : { display: "block" }
                                        }
                                      >
                                        Archive
                                      </MenuItem>
                                      <MenuItem
                                        onClick={(e) =>
                                          handlePatchRecord(e, row, false)
                                        }
                                        style={
                                          publishedActive
                                            ? { display: "none" }
                                            : { display: "block" }
                                        }
                                      >
                                        Unarchive
                                      </MenuItem>
                                    </Menu>
                                  </>
                                ) : column.format === "Date" ? (
                                  getDate(value)
                                ) : (
                                  value
                                )}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                </>
              ) : (
                (
                  <TableCell colspan="7" style={{ "text-align": "center", margin: "10px 0px" }} >
                    Records Not Available</TableCell>

                )
              )}

            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
}

export default CMSOverView;
